import axiosInstance, { type ApiResponse } from './axios'
import ApiURL from './api.url'
import { ResultClass } from './types'

/**
 * 核心请求工具函数
 */
export const request = async <T = any>(
  apiURL: ApiURL,
  params: Record<string, any> = {}
): Promise<ResultClass<T>> => {
  const url = apiURL.URLString()
  const method = apiURL.method || 'GET'
  const isShowLog = apiURL.isShowLog

  if (isShowLog) {
    console.log(`[Request] ${method} ${url}`, params)
  }

  try {
    const response = await axiosInstance.request<ApiResponse<T>>({
      url,
      method,
      [method.toUpperCase() === 'GET' ? 'params' : 'data']: params
    })

    const { data } = response
    
    // 返回 ResultClass 保持向后兼容，但内部逻辑大大简化
    const result = ResultClass.of(data.content, true)
    result.parameters = params
    
    if (isShowLog) {
      console.log(`[Response] ${url}`, result.data)
    }

    return result
  } catch (error: any) {
    console.error(`[Request Error] ${url}:`, error)
    // 错误已经在 axios 拦截器中通过 toast 提示
    return ResultClass.of<T>(null as any, false)
  }
}

export default { request }
